import React, { useRef } from 'react';
import "./App.css";


const PIO = (props) => {


    const textAreaRef = useRef(null);

    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    var alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";



    function copyToClipboard(e) {

        var range = document.createRange();
        range.selectNode(textAreaRef.current);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);

        //copyToClipboard1(textAreaRef.current.innerHTML);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        // This is just personal preference.
        // I prefer to not show the the whole text area selected.
        //e.target.focus();
    };
    function sendToPrinter(e) {

        var range = document.createRange();
        range.selectNode(textAreaRef.current);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);

        printPreview("<html><head><link rel='stylesheet' href='" + window.location.origin + "/App.css' /></head><body>" + textAreaRef.current.innerHTML + "</body></html>");
        //document.execCommand('copy');
        window.getSelection().removeAllRanges();
        // This is just personal preference.
        // I prefer to not show the the whole text area selected.
        //e.target.focus();
    };
    function printPreview(data) {

        var pri = window.open("", "_blank");
        pri.document.open();
        pri.document.write(data);
        pri.document.close();
        pri.focus();
        pri.print();
    }
    function copyToClipboard1(data) {
        function listener(e) {
            e.clipboardData.setData("text/html", data);
            e.clipboardData.setData("text/plain", data);
            e.preventDefault();
        }

        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
    };

    return (
        <div>
            {
                /* Logical shortcut for only displaying the 
                   button if the copy command exists */
                document.queryCommandSupported('copy') &&
                <div>
                    <button onClick={copyToClipboard}>Copy</button>
                </div>
            }
            <div className="TableMainCell myPagesClass" id="rtiApplication" ref={textAreaRef}>
                <div
                    className="Table"
                    style={{ background: "silver", width: "650px" }}
                >
                    <div className="TableRow">
                        <div className="TableLabelDoubleCell"
                            style={{ width: "auto", textAlign: "left" }}>To,
                            {[...Array(111)].map((x, i) => '\u00a0')}Date: {(new Date().getDate()).toString().padStart(2, '0')}{" "}
                            {monthNames[new Date().getMonth()]},{" "}
                            {new Date().getFullYear()}</div>
                    </div>
                    <div className="TableRow">
                        <div className="new-line" style={{ paddingLeft: 25 }}>
                            &nbsp;&nbsp;Public Information Officer,
                    <br />
                            {"\u00a0\u00a0" + props.ToAddress.replace(/\n/g, "\n\u00a0\u00a0")}
                        </div>
                    </div>
                    <div className="TableRow">
                        <div className="TableLabelDoubleCell"><br />From,</div>
                    </div>
                    <div className="TableRow">
                        <div className="new-line" style={{ paddingLeft: 25 }}>
                            {"\u00a0\u00a0" + props.From},
                    <br />
                            {"\u00a0\u00a0" + props.FromAddress.replace(/\n/g, "\n\u00a0\u00a0")}
                        </div>
                    </div>
                </div>
                <div
                    className="Table"
                    style={{
                        background: "silver",
                        width: "650px",
                    }}
                >
                    <div className="TableRow">
                        <div className="TableLabelCell">
                            <br />
                            Sub: Application for obtaining information under Section
                            6(1) of RTI Act 2005
                    <br />{props.Reference.length > 0 ? <br /> : ""}
                            {props.Reference.length > 0 ? "Ref : " + props.Reference : ""}{props.Reference.length > 0 ? <br /> : ""}
                            <br />
                            Respected Officer
                    <br />
                            <br />
                            As per the Right to Information Act, 2005, please provide me
                            certified copies of below information in the form of
                            documents and records according to Section 2(f) of RTI Act
                            2005 in ENGLISH of
                    <br />
                            <div style={{ "textAlign": "left" }}>
                                <br />{props.Subject === undefined ? "" : "".padStart(parseInt((140 - ((props.Subject.length + 2) * 1.4)) / 2), '\u00a0') + "\"" + props.Subject + "\""}
                                <br />
                                {"".padStart(parseInt((140 - (("hereinafter referred to as".length) * 1.4)) / 2), '\u00a0') + "hereinafter referred to as"}
                                <br />
                                {"".padStart(parseInt((140 - (("\"Subject\"".length) * 1.4)) / 2), '\u00a0') + "\"Subject\""}
                                <br /></div>
                            <br />
                            {props.InformationRequired.map((info, idx) => (
                                <p>
                                    &nbsp;&nbsp;{idx + 1})&nbsp;{info}
                                    <br />
                                </p>
                            ))}
                            <p>
                                &nbsp;&nbsp;{props.InformationRequired.length + 1})&nbsp;Below details of the person replying this RTI application
                                <br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;i) Full Name&nbsp;&nbsp;&nbsp;&nbsp;ii) Designation&nbsp;&nbsp;&nbsp;&nbsp;iii) Staff Id / Employee Id
                                <br /><br />
                            </p>
                            Postal order {props.PostalOrder} of Rs 10/- enclosed as
                            RTI fees towards this application.
                    <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
                <div
                    className="Table"
                    style={{ background: "silver", width: "650px" }}
                >
                    <div className="TableRow">
                        <div className="TableLabelDoubleCell"> {"Yours Sincerely,".padStart(125, '\u00a0')}
                            <br />
                            {props.From.padStart(122, '\u00a0')}</div>
                    </div>
                </div>
                <div
                    className="Table"
                    style={{ background: "silver", width: "650px" }}
                >
                    {props.Annexures.length > 0 ? (
                        <div className="TableRow">
                            <div className="TableLabelDoubleCell"><br />ANNEXURES:</div>
                        </div>
                    ) : (
                            ""
                        )}
                    {props.Annexures.map((annex, idx) => (
                        <div className="TableRow">
                            <div className="TableLabelDoubleCell">
                                <br />
                                &nbsp;&nbsp;{alphabets.charAt(idx)})&nbsp;{annex}
                            </div>
                        </div>
                    ))}
                </div>
                <div
                    className="Table"
                    style={{ background: "silver", width: "650px" }}
                >
                    {props.CopiedTo.length > 0 ? (
                        <div className="TableRow">
                            <div className="TableLabelDoubleCell"><br />Copied To:</div>
                        </div>
                    ) : (
                            ""
                        )}
                    {props.CopiedTo.map((copy, idx) => (
                        <div className="TableRow">
                            <div className="TableLabelDoubleCell new-line" style={{ paddingLeft: 25 }}>
                                <br />
                                {"\u00a0\u00a0" + copy.replace(/\n/g, "\n\u00a0\u00a0")}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default PIO